import classNames from "classnames";
import { DropzoneContextProvider } from "client/Contexts/DropzoneContext";
import { useDropzoneHandlers } from "client/Hooks";
import { setTrackingId } from "client/Misc/utils";
import { PropsWithChildren, ReactElement } from "react";
import styles from "./DropZone.module.less";

export type DropZoneProps = {
	height?: "fill" | "auto";
	isDisabled?: boolean;
	trackingId: string;
};

export const DropZone = (props: PropsWithChildren<DropZoneProps>): ReactElement => {
	const {
		height = "auto",
		isDisabled = false,
		trackingId,
		children
	} = props;

	const {
		dropzoneContext,
		isDropzoneActive,
		...dragHandlers
	} = useDropzoneHandlers(!isDisabled);

	return (
		<div
			{...setTrackingId(trackingId)}
			{...dragHandlers}
			className={classNames(
				styles.root,
				{
					[styles.root_fillHeight]: height === "fill",
					[styles.root_isDropZoneActive]: isDropzoneActive
				}
			)}
		>
			<DropzoneContextProvider value={dropzoneContext}>
				{children}
			</DropzoneContextProvider>
		</div>
	);
};
DropZone.displayName = "DropZone";